import React, { useEffect, useRef } from 'react';
import styles from './wistia-video.module.css';

interface WistiaVideoProps {
  embedUrl: string;
  width?: string;
  height?: string;
  padding?: string;
  responsive?: boolean;
}

export default function WistiaVideo({
  embedUrl,
  width = '100%',
  height = '100%',
  responsive = true,
  padding = '56.25% 0 0',
}: WistiaVideoProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  // Extracts media ID from embed URL/snippet
  const extractWistiaId = (url: string): string | null => {
    const regex = /\/(?:medias|iframe)\/([a-zA-Z0-9]{10})/;
    const match = url.match(regex);
    return match ? match[1] : null;
  };

  const wistiaId = extractWistiaId(embedUrl);

  useEffect(() => {
    if (!wistiaId) return;

    // Check if script already exists
    if (!document.querySelector('script[src*="fast.wistia.com/assets/external/E-v1.js"]')) {
      const script = document.createElement('script');
      script.src = 'https://fast.wistia.com/assets/external/E-v1.js';
      script.async = true;
      document.body.appendChild(script);
    }

    // Wistia will automatically init any `.wistia_embed` class elements
    return () => {
      // Optional: cleanup logic
    };
  }, [wistiaId]);

  if (!wistiaId) return null;

  if (!responsive) {
    return (
      <div
        ref={containerRef}
        className={`wistia_embed wistia_async_${wistiaId}`}
        style={{ height: height, width: width }}
      >
        &nbsp;
      </div>
    );
  }

  return (
    <div
      ref={containerRef}
      className={`wistia_responsive_padding ${styles.videoWrapper}`}
      style={{
        padding: padding,
        position: 'relative',
        width: width,
        height: height,
      }}
    >
      <div
        className="wistia_responsive_wrapper"
        style={{
          position: 'absolute',
          height: '100%',
          left: 0,
          top: 0,
          width: '100%',
        }}
      >
        <div
          className={`wistia_embed wistia_async_${wistiaId} videoFoam=true`}
          style={{
            height: '100%',
            width: '100%',
            position: 'relative',
          }}
        ></div>
      </div>
    </div>
  );
}
